import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import './noResults.less';

interface Props {
  children: any;
  noResults: boolean;
  customMessage?: string;
}

const NoResults = ({ children, noResults, customMessage }: Props) => {
  const { general } = useSelector(
    (data: RootState) => data.config.translations
  );

  return noResults ? (
    <h4 className="no-results">{customMessage || general?.noResults}</h4>
  ) : (
    children
  );
};

export default NoResults;
